import React from 'react'
// import {helmet} from "react-helmet";
import './Privacy.css';

export default function PrivacyPolicy() {
  return (
    <>
    <div class="privacy-hero">
      <helmet>
        <title>Privacy Policy | Shivam Digital</title>
        <meta name="description" content="Read Shivam Digital's privacy policy to understand how your information is collected, used, and protected." />
        <meta name="keywords" content="Privacy Policy, User Data Protection, Information Collection, Shivam Digital Privacy, GDPR Policy, Website Privacy Policy" />
      </helmet>
  <h1>Privacy Policy</h1>
</div>

<section class="privacy-content">
  <div class="privacy-container">
    <p><strong>Last Updated:</strong> July 25, 2025</p>

    <h2>1. Introduction</h2>
    <p>Welcome to Shivam Digital. We respect your privacy and are committed to protecting your personal data. This policy outlines how we handle your information.</p>

    <h2>2. Information We Collect</h2>
    <p>We may collect your name, email, phone number, and message content when you contact us via the website. We also collect anonymous website analytics.</p>

    <h2>3. How We Use Your Information</h2>
    <p>We use your information to respond to your inquiries, provide services, improve our website, and for marketing communications (with your consent).</p>

    <h2>4. Data Sharing</h2>
    <p>We do not sell your personal information. We may share it with trusted partners (like EmailJS) only to provide better service, with appropriate safeguards.</p>

    <h2>5. Cookies</h2>
    <p>Our website may use cookies to enhance user experience. You can control cookies through your browser settings.</p>

    <h2>6. Your Rights</h2>
    <p>You have the right to request access, correction, or deletion of your personal data. Contact us to exercise these rights.</p>

    <h2>7. Security</h2>
    <p>We take reasonable measures to protect your data, but no method is 100% secure. Please use the site at your own risk.</p>

    <h2>8. Changes to This Policy</h2>
    <p>We may update this policy occasionally. Please review it regularly for changes.</p>

    <h2>9. Contact Us</h2>
    <p>If you have any questions or concerns about this policy, contact us at <a href="mailto:shivamraj1342@gmail.com">shivamraj1342@gmail.com</a>.</p>
  </div>
</section>
</>
  )
}
